import Input from "../components/Input";

const AddressUsFields = ({ city, st, zip, handleUpdate, errors }) => {
	return (
		<div className="form-group three">
			<Input
				name="city"
				label="City"
				reqd={true}
				value={city || ""}
				autocomplete="off"
				update={handleUpdate}
				errors={errors}
			/>
			<Input
				name="st"
				label="State (2-letter)"
				reqd={true}
				value={st || ""}
				autocomplete="off"
				update={handleUpdate}
				errors={errors}
			/>
			<Input
				name="zip"
				label="Zip Code"
				reqd={true}
				value={zip || ""}
				autocomplete="off"
				update={handleUpdate}
				errors={errors}
			/>
		</div>
	);
};

export default AddressUsFields;
